// extracted by mini-css-extract-plugin
export default {"linksSection":"qH-z"};